import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Haberler from './pages/Haberler';
import HaberDetay from './pages/HaberDetay';
import Duyurular from './pages/Duyurular';
import Etkinlikler from './pages/Etkinlikler';
import Anketler from './pages/Anketler';
import VefatEdenler from './pages/VefatEdenler';
import VefatDetay from './pages/VefatDetay';
import Galeri from './pages/Galeri';
import AlbumDetay from './pages/AlbumDetay';
import VideoGaleri from './pages/VideoGaleri';
import Hakkimizda from './pages/Hakkimizda';
import Iletisim from './pages/Iletisim';
import Derneklerimiz from './pages/Derneklerimiz';
import DernekDetay from './pages/DernekDetay';
import DynamicPage from './pages/DynamicPage';
import Uyelik from './pages/Uyelik';
import Bagis from './pages/Bagis';
import Chat from './pages/Chat';
import Profil from './pages/Profil';
import Admin from './pages/Admin';
import '@/App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => res.json())
        .then(data => {
          if (data.id) setUser(data);
          else localStorage.removeItem('token');
        })
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="text-xl text-amber-800">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Navbar user={user} setUser={setUser} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/haberler" element={<Haberler />} />
          <Route path="/haberler/:id" element={<HaberDetay />} />
          <Route path="/duyurular" element={<Duyurular />} />
          <Route path="/etkinlikler" element={<Etkinlikler />} />
          <Route path="/anketler" element={<Anketler />} />
          <Route path="/vefat-edenler" element={<VefatEdenler />} />
          <Route path="/vefat-edenler/:id" element={<VefatDetay />} />
          <Route path="/galeri" element={<Galeri />} />
          <Route path="/galeri/:slug" element={<AlbumDetay user={user} />} />
          <Route path="/video-galeri" element={<VideoGaleri />} />
          <Route path="/hakkimizda" element={<Hakkimizda />} />
          <Route path="/iletisim" element={<Iletisim />} />
          <Route path="/derneklerimiz" element={<Derneklerimiz />} />
          <Route path="/derneklerimiz/:slug" element={<DernekDetay />} />
          <Route path="/koyumuz/:slug" element={<DynamicPage />} />
          <Route path="/sayfa/:slug" element={<DynamicPage />} />
          <Route path="/uyelik" element={<Uyelik setUser={setUser} />} />
          <Route path="/bagis" element={<Bagis />} />
          <Route path="/chat" element={user ? <Chat user={user} /> : <Navigate to="/uyelik" />} />
          <Route path="/profil" element={user ? <Profil /> : <Navigate to="/uyelik" />} />
          <Route path="/admin" element={(user?.role === 'admin' || user?.role === 'editor') ? <Admin user={user} /> : <Navigate to="/" />} />
        </Routes>
        <Toaster position="top-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;
